export default __webpack_public_path__ + "static/media/img (5).84f27c75.jpg";